import { useId } from "react";
import { useHinweis } from "./Hinweise";
import s from "./ui.module.css";

interface HakenProps {
  /** Erledigt? */
  an: boolean;
  /** Titel der Aufgabe. Vorgelesen wird „Erledigt: Titel“, dazu gedrückt oder nicht gedrückt. */
  titel: string;
  onUmschalten: () => void;
  /** Ohne Recht: warum der Haken nicht geht. Er bleibt fokussierbar, liest den Grund vor und zeigt ihn beim Klick als Hinweis. */
  gesperrt?: string | null | undefined;
}

/** Haken vor einer Aufgabe (BAUPLAN-PAKETE.md, Abschnitt 4.1): ein Klick erledigt oder öffnet wieder. Erledigt ist ein grüner Kreis
 *  mit Haken, offen ein leerer Kreis. Status nie nur als Farbe: der Haken selbst ist das Zeichen. */
export function Haken({ an, titel, onUmschalten, gesperrt }: HakenProps) {
  const { zeigen } = useHinweis();
  const grundId = useId();
  return (
    <button
      type="button"
      className={s.haken}
      aria-pressed={an}
      aria-label={`Erledigt: ${titel}`}
      aria-disabled={gesperrt ? true : undefined}
      aria-describedby={gesperrt ? grundId : undefined}
      title={gesperrt ?? undefined}
      onClick={() => (gesperrt ? zeigen(gesperrt) : onUmschalten())}
    >
      <span className={s.hakenKreis} aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <path d="M6 12.5l4 4 8-9" />
        </svg>
      </span>
      {gesperrt ? (
        <span id={grundId} className={s.nurLeser}>
          {gesperrt}
        </span>
      ) : null}
    </button>
  );
}
